import React, { useState } from 'react';
import axios from 'axios';
import {get, method} from 'lodash';

import Modal from './Modal';
import {useModal} from '../hooks';
import {
  CSRF_TOKEN,
  requestCallback
} from '../lib/helpers';

const GiftModal = ({
  klassName = 'MainHeader__right__a MainHeader__right__a--bright-blue',
  title,
  label,
  gift
}) => {
  const [
    modal,
    modalSet
  ] = useModal({
    keyboardBindings: true,
  })

  function toggleModal() {
    modalSet(!modal)
  }

  const [createBtnText, setCreateBtnText] = useState("Submit")
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [icon, setIcon] = useState(null)
  const [inactiveIcon, setInactiveIcon] = useState(null)

  const changeText = (text) => setCreateBtnText(text)
  const handleIconAdded = function(e) {
    console.log(e.target.files[0])
    setIcon(get(e, 'target.files[0]'))
  }
  const handleInactiveIconAdded = (e) => setInactiveIcon(get(e, 'target.files[0]'))

  const gift_order = get(gift, 'order') || 1
  const gift_name = get(gift, 'name')
  const gift_amount = get(gift, 'amount')
  const gift_is_active = get(gift, 'isActive')
  const gift_type = get(gift, 'giftType')

  return (
    <React.Fragment>
      <a
        name={name}
        className={klassName}
        onClick={toggleModal}
      >
        {label}
      </a>

      <Modal
        isActive={modal}
        onToggleModal={() => {
          modalSet(false)
        }}
        reset
      >
        <div className='GiftModal'>
          <h3 className='Modal__h3'>{title}</h3>

          <form
            className='GiftModal__form'
            onSubmit={(e) => {
              e.preventDefault()

              setIsSubmitted(true)
              changeText('Processing...')

              const $els = e.target.elements

              const formData = new FormData();
              formData.append('gift[order]', get($els, 'order.value').trim())
              formData.append('gift[name]', get($els, 'name.value').trim())
              formData.append('gift[icon]', icon)
              formData.append('gift[inactive_icon]', inactiveIcon)
              formData.append('gift[amount]', get($els, 'amount.value').trim())
              formData.append('gift[is_active]', get($els, 'is_active.value').trim())
              formData.append('gift[gift_type]', get($els, 'gift_type.value').trim())
              formData.append('gift[currency_code]', '¥')
              formData.append('authenticity_token', CSRF_TOKEN)

              const headers = {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }

              const [method, endpoint] = gift ?
                ['PUT', `/${gon.currentProvider}/api/gifts/${gift.id}`] :
                ['POST', `/${gon.currentProvider}/api/gifts`]

              requestCallback(
                axios({
                  method: method,
                  url: endpoint,
                  data: formData,
                  headers: headers
                })
              )
            }}
          >
            <input
              type='number'
              min='1'
              max='999'
              className='Input'
              name='order'
              placeholder='Order: 1~999'
              defaultValue={gift_order}
              required
            />

            <input
              type='text'
              className='Input'
              name='name'
              placeholder='Name'
              defaultValue={gift_name}
              required
            />

            <input
              type='file'
              className='Input'
              name='icon'
              accept="image/*"
              onChange={handleIconAdded}
            />

            <input
              type='file'
              className='Input'
              name='inactive_icon'
              accept="image/*"
              onChange={handleInactiveIconAdded}
            />

            <input
              type='text'
              className='Input'
              name='amount'
              placeholder='Amount'
              defaultValue={gift_amount}
              required
            />

            <div className="GiftModal__form__checkbox">
              <label className="GiftModal__form__checkbox__label">
                <input
                  type="checkbox"
                  name="is_active"
                  defaultChecked={gift_is_active == undefined ? true : gift_is_active }
                />
                <span className="CheckBox"></span>
                <span>Active</span>
              </label>
            </div>

            <select className='Select Input' name='gift_type'>
              <option value='paid'>Paid</option>
              <option value='free'>Free</option>
              <option value='view_ads'>View Ads</option>
            </select>

            <div className='GiftModal__form__buttons' disabled={isSubmitted}>
              <a
                className='Button Button--gray-light'
                onClick={() => {
                  modalSet(false)
                }}
              >
                Cancel
              </a>

              <button
                className='Button Button--red'
              >
                {createBtnText}
              </button>
            </div>
          </form>
        </div>
      </Modal>
    </React.Fragment>
  );
}

export default GiftModal
